<template>
  <div>
    <v-dialog
      v-model="isShowDialog"
      persistent
      :width="matchPanelSize"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between ">
          <span>CREATE OBJECT</span>
          <div>
            <v-btn 
              :disabled="loading"
              outlined
              @click="editDeviceHide"
              class="text-right text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
              :x-large="$vuetify.breakpoint.name == 'xl'"
              :large="$vuetify.breakpoint.name == 'lg'"
            >
              <v-icon color="white">
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row class="mt-3" v-if="(step == 1)">
            <v-col class="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <v-row>
                <v-col class="col-6">
                  <v-select
                    :disabled="(loading || !isEditDeviceFields)"
                    outlined
                    v-model="SubjectCreationDto.DeviceTypeId"
                    :items="getDeviceTypes.filter(d => d.id != 2)"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '400', offsetY: true }"
                    label="Device"
                    persistent-hint
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="(loading || !isEditDeviceFields)"
                    label="DVC-Point IMEI"
                    outlined
                    v-model="SubjectCreationDto.DeviceImei"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="(loading || !isEditDeviceFields)"
                    label="SIM object phone number"
                    outlined
                    v-model="SubjectCreationDto.PhoneNumber"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-select
                    :disabled="(loading || !isEditDeviceFields)"
                    outlined
                    v-model="SubjectCreationDto.SubDeviceTypeId"
                    :items="getSubDeviceTypes"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '400', offsetY: true }"
                    label="Object type"
                    persistent-hint
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col
                  :class="(SubjectCreationDto.SubDeviceTypeId == 1 || SubjectCreationDto.SubDeviceTypeId == 2 || SubjectCreationDto.SubDeviceTypeId == 3) ? 'col-6' : 'col-12'">
                  <v-text-field
                    :disabled="(loading || !isEditDeviceFields)"
                    label="Enter Polling TimeOut"
                    outlined
                    v-model="SubjectCreationDto.ModuleAConfig.PollingTimeOut"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-text-field
                    v-if="(SubjectCreationDto.SubDeviceTypeId == 1 || SubjectCreationDto.SubDeviceTypeId == 2 || SubjectCreationDto.SubDeviceTypeId == 3)"
                    :disabled="(loading || !isEditDeviceFields)"
                    label="Serial Number"
                    outlined
                    v-model="SubjectCreationDto.SubDeviceSerialNumber"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="d-flex justify-center" v-if="(step == 1)">
            <v-col class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <v-row no-gutters class="d-flex justify-space-around">
                <v-col class="col-12" v-if="(SubjectCreationDto.SubDeviceTypeId == 4)">
                  <v-row>
                    <v-col :class="$vuetify.breakpoint.name == 'xs' ? 'col-6' : 'col-4'">
                      <v-text-field
                        class="mt-3"
                        :disabled="(loading || !isEditDeviceFields)"
                        label="Enter temperature sensor name"
                        outlined
                        v-model="SubjectCreationDto.ModuleAConfig.TemperatureName"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-3"
                        :disabled="(loading || !isEditDeviceFields)"
                        label="Enter sensor name"
                        outlined
                        v-model="SubjectCreationDto.ModuleAConfig.Adc1.Name"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-3"
                        :disabled="(loading || !isEditDeviceFields)"
                        label="Enter sensor name"
                        outlined
                        v-model="SubjectCreationDto.ModuleAConfig.Adc2.Name"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col :class="$vuetify.breakpoint.name == 'xs' ? 'col-6' : 'col-4'">
                      <v-select
                        class="mt-3"
                        :disabled="true"
                        outlined
                        v-model="selected"
                        :items="[{name: 'Temperature', id: 1}]"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Sensor type"
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                      <v-select
                        class="mt-3"
                        :disabled="(loading || !isEditDeviceFields)"
                        outlined
                        v-model="SubjectCreationDto.ModuleAConfig.Adc1.DescriptorTypeId"
                        :items="getSubjectCreationDatas.descriptors"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Sensor type"
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                      <v-select
                        class="mt-3"
                        :disabled="(loading || !isEditDeviceFields)"
                        outlined
                        v-model="SubjectCreationDto.ModuleAConfig.Adc2.DescriptorTypeId"
                        :items="getSubjectCreationDatas.descriptors"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Sensor type"
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col :class="$vuetify.breakpoint.name == 'xs' ? 'col-6' : 'col-2'">
                      <v-text-field
                        class="mt-3"
                        :disabled="true"
                        label="Multiplier"
                        value="1"
                        outlined
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-3"
                        label="Multiplier"
                        outlined
                        disabled
                        v-model="getMultiplierByDescriptorTypeIdAdc1"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-3"
                        label="Multiplier"
                        outlined
                        disabled
                        v-model="getMultiplierByDescriptorTypeIdAdc2"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col :class="$vuetify.breakpoint.name == 'xs' ? 'col-6' : 'col-2'">
                      <v-text-field
                        class="mt-3"
                        :disabled="true"
                        label="Measure type"
                        value="C"
                        outlined
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-3"
                        label="Measure type"
                        outlined
                        disabled
                        v-model="getMeasureTypeNameAdc1"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-3"
                        label="Measure type"
                        outlined
                        disabled
                        v-model="getMeasureTypeNameAdc2"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col class="col-6 d-flex justify-start">
                </v-col>
                <v-col class="col-6 d-flex justify-end">
                  <v-btn :disabled="loading || isNotValidStep1" depressed outlined large @click="(step=2)"
                    class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                    :x-large="$vuetify.breakpoint.name == 'xl'"
                    :large="$vuetify.breakpoint.name == 'lg'">
                    NEXT
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-3" v-if="(step == 2)">
            <v-col class="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <v-row>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="(loading || !isEditDeviceFields)"
                    label="Object title"
                    outlined
                    v-model="SubjectCreationDto.Name"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="(loading || !isEditDeviceFields)"
                    label="Object address"
                    outlined
                    v-model="fullAddress"
                    @change="fullAddressChange"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-select
                    :disabled="(loading || !isEditDeviceFields)"
                    outlined
                    v-model="SubjectCreationDto.SupplierId"
                    :items="getSubjectCreationDatas.suppliers.filter(s => s.id > 0)"
                    item-text="title"
                    item-value="id"
                    :menu-props="{ maxHeight: '400', offsetY: true }"
                    label="Provider"
                    persistent-hint
                    dense
                    hide-details
                    @change="changeProvider"
                  ></v-select>
                </v-col>
                <v-col class="col-6">
                  <v-select
                    :disabled="true"
                    outlined
                    v-model="SubjectCreationDto.TarifId"
                    :items="getSubjectCreationDatas.tariffs"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '400', offsetY: true }"
                    label="Tariff"
                    persistent-hint
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col class="col-6">
                  <v-select
                    :disabled="(loading || !isEditDeviceFields)"
                    outlined
                    v-model="SubjectCreationDto.SimCorpId"
                    :items="getSubjectCreationDatas.simCorps.filter(s => s.id > 0)"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '400', offsetY: true }"
                    label="Sim corporation"
                    persistent-hint
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col class="col-6">
                  <v-select
                    :disabled="(loading || !isEditDeviceFields)"
                    outlined
                    v-model="SubjectCreationDto.ProviderId"
                    :items="getSubjectCreationDatas.providers.filter(s => s.id > 0)"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '400', offsetY: true }"
                    label="Internet provider"
                    persistent-hint
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col class="col-6">
                  <v-select
                    :disabled="(loading || !isEditDeviceFields)"
                    outlined
                    v-model="SubjectCreationDto.IsBatteryPower"
                    :items="powerType"
                    item-text="name"
                    item-value="value"
                    :menu-props="{ maxHeight: '400', offsetY: true }"
                    label="Power type"
                    persistent-hint
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col class="col-6">
                  <v-select
                    :disabled="(loading || !isEditDeviceFields)"
                    outlined
                    v-model="SubjectCreationDto.ImportanceRank"
                    :items="getSubjectCreationDatas.importanceRank.filter(s => s.id > 0)"
                    :menu-props="{ maxHeight: '400', offsetY: true }"
                    item-text="name"
                    item-value="id"
                    label="Importance rank"
                    persistent-hint
                    dense
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="d-flex justify-center" v-if="(step == 2)">
            <v-col class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <v-row no-gutters class="mt-3">
                <v-col class="col-6 d-flex justify-start">
                  <v-btn :disabled="loading" depressed outlined large @click="(step=1)"
                    class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                    :x-large="$vuetify.breakpoint.name == 'xl'"
                    :large="$vuetify.breakpoint.name == 'lg'">
                    BACK
                  </v-btn>
                </v-col>
                <v-col class="col-6 d-flex justify-end">
                  <v-btn :disabled="loading || isNotValidStep2" depressed outlined large @click="createDevice"
                    class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                    :x-large="$vuetify.breakpoint.name == 'xl'"
                    :large="$vuetify.breakpoint.name == 'lg'">
                    CREATE
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'
  export default {
    props: ['isShowDialog', 'userRegisterData'],
    name: 'CreateDevice',
    data(){
      return {
        selected: 1,
        fullAddress: '',
        step: 1,
        isEditDeviceFields: true,
        selectedDeviceType: null,
        loading: false,
        powerType:[
          {
            name: 'Battery',
            value: true
          },
          {
            name: 'PowerSupply',
            value: false
          }
        ],
        SubjectCreationDto:{
          DeviceTypeId: '',
          DeviceImei: '',
          PhoneNumber: '',
          SubDeviceTypeId: 0,
          SubDeviceSerialNumber: '',
          MeterNetworkNumber:'',
          ModuleAConfig:{
            PollingTimeOut: 0,
            TemperatureName: '',
            Adc1:{
              Name: '',
              DescriptorTypeId: 0,
            },
            Adc2:{
              Name: '',
              DescriptorTypeId: 0,
            }
          },
          Name: '',
          FullAddress: {
            FullAddress: null,
            Latitude: null,
            Longitude: null,
            Country: null,
            Area: null,
            City: null,
            Street: null,
            House: null
          },
          SupplierId: 0,
          TarifId: 0,
          ProviderId: 0,
          IsBatteryPower: false,
          ImportanceRank: '',
          SimCorpId: 0
        }
      }
    },
    computed:{
      ...mapGetters(['getDeviceTypes', 'getSubDeviceTypes', 'getSubjectCreationDatas']),
      isNotValidStep1(){
        if(this.SubjectCreationDto.DeviceTypeId > 0 && this.SubjectCreationDto.PhoneNumber.length > 6 && this.SubjectCreationDto.SubDeviceTypeId > 0){
          if(this.SubjectCreationDto.SubDeviceTypeId == 1 && this.SubjectCreationDto.SubDeviceSerialNumber.length > 4){
            return false
          }
          if(this.SubjectCreationDto.SubDeviceTypeId == 2 && this.SubjectCreationDto.SubDeviceSerialNumber.length > 4/* && this.SubjectCreationDto.MeterNetworkNumber.length > 1*/){
            return false
          }
          if(this.SubjectCreationDto.SubDeviceTypeId == 3 && this.SubjectCreationDto.SubDeviceSerialNumber.length > 4){
            return false
          }
          if(this.SubjectCreationDto.SubDeviceTypeId == 5){
            return false
          }
          if(this.SubjectCreationDto.SubDeviceTypeId == 4 && this.SubjectCreationDto.ModuleAConfig.TemperatureName.length > 1
          && this.SubjectCreationDto.ModuleAConfig.Adc1.Name.length > 1 && this.SubjectCreationDto.ModuleAConfig.Adc2.Name.length > 1
          && this.SubjectCreationDto.ModuleAConfig.Adc1.DescriptorTypeId > 0 && this.SubjectCreationDto.ModuleAConfig.Adc2.DescriptorTypeId > 0){
            return false
          }
        }
        return true
      },
      isNotValidStep2(){
        console.log(this.SubjectCreationDto)
        console.log(this.fullAddress)
        if(this.SubjectCreationDto.Name.length > 3 && this.fullAddress != ''
         && this.SubjectCreationDto.SupplierId > 0 && this.SubjectCreationDto.TarifId > 0
         && this.SubjectCreationDto.SimCorpId > 0 && this.SubjectCreationDto.ImportanceRank > 0
          && this.SubjectCreationDto.ModuleAConfig.PollingTimeOut >= 1 && this.SubjectCreationDto.ModuleAConfig.PollingTimeOut <= 5){
          return false
        }
        return true
      },
      getMultiplierByDescriptorTypeIdAdc1(){
        const desc = this.getSubjectCreationDatas.descriptors.filter(d => d.id == this.SubjectCreationDto.ModuleAConfig.Adc1.DescriptorTypeId)
        if(desc.length == 0){
          return null
        }else{
          return desc[0].multiplier
        }
      },
      getMultiplierByDescriptorTypeIdAdc2(){
        const desc = this.getSubjectCreationDatas.descriptors.filter(d => d.id == this.SubjectCreationDto.ModuleAConfig.Adc2.DescriptorTypeId)
        if(desc.length == 0){
          return null
        }else{
          return desc[0].multiplier
        }
      },
      getMeasureTypeNameAdc1(){
        const descriptor = this.getSubjectCreationDatas.descriptors.filter(d => d.id == this.SubjectCreationDto.ModuleAConfig.Adc1.DescriptorTypeId)
        if(descriptor.length == 0){
          return null
        }
        console.log(descriptor)
        const desc = this.getSubjectCreationDatas.measureTypes.filter(d => d.id == descriptor[0].measureTypeId)
        console.log(desc)
        if(desc.length == 0){
          return null
        }else{
          return desc[0].value
        }
      },
      getMeasureTypeNameAdc2(){
        const descriptor = this.getSubjectCreationDatas.descriptors.filter(d => d.id == this.SubjectCreationDto.ModuleAConfig.Adc2.DescriptorTypeId)
        if(descriptor.length == 0){
          return null
        }
        const desc = this.getSubjectCreationDatas.measureTypes.filter(d => d.id == descriptor[0].measureTypeId)
        if(desc.length == 0){
          return null
        }else{
          return desc[0].value
        }
      },
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      }
    },
    methods:{
      ...mapActions(['createUserByAgregator', 'getLocationInfo', 'createSubject', 'getDeviceTypesAction', 'getSubDeviceTypesAction', 'getSubjectCreationData', 'createUserSubject']),
      editDeviceHide(){
        this.step = 1
        this.$emit('HideCreateDevice')
      },
      changeProvider(){
        const sup = this.getSubjectCreationDatas.tariffs.filter(s => s.supplierId == this.SubjectCreationDto.SupplierId)
        if(sup.length > 0){
          this.SubjectCreationDto.TarifId = sup[0].id
        }
      },
      async fullAddressChange(){
        await this.getLocationInfo(this.fullAddress)
        .then(result => {
          if(result.data && result.data.length > 0){
            const fullInfoAddress = result.data[0]
            this.SubjectCreationDto.FullAddress.FullAddress = fullInfoAddress.display_name
            this.SubjectCreationDto.FullAddress.Latitude = fullInfoAddress.lat
            this.SubjectCreationDto.FullAddress.Longitude = fullInfoAddress.lon
            this.SubjectCreationDto.FullAddress.Country = fullInfoAddress.address.country
            this.SubjectCreationDto.FullAddress.Area = fullInfoAddress.address.state
            this.SubjectCreationDto.FullAddress.City = fullInfoAddress.address.city
            this.SubjectCreationDto.FullAddress.Street = fullInfoAddress.address.road
            this.SubjectCreationDto.FullAddress.House = fullInfoAddress.address.house_number
            this.fullAddress = fullInfoAddress.display_name
          }
        })
        .catch(e => {
          console.log(e)
        })
      },
      async createDevice(){
        this.$root.$emit('loading', "start")
        console.log(this.SubjectCreationDto)
        console.log(this.userRegisterData)
        if(this.userRegisterData != null){
          await this.createUserSubject({subjectCreationDto: this.SubjectCreationDto, userEditDto: this.userRegisterData})
          .then(res => {
            console.log(res)
            this.$root.$emit('loading', "end")
            this.$noty.success(`Success`)
            this.isShowDialog = false
          })
          .catch(er => {
            console.log(er)
            this.$root.$emit('loading', "end")
            this.$noty.error(`Error: ${er.description}`)
          })
        }else{
          await this.createSubject(this.SubjectCreationDto)
          .then(res => {
            console.log(res)
            this.$root.$emit('loading', "end")
            this.$noty.success(`Success`)
            this.isShowDialog = false
          })
          .catch(er => {
            console.log(er)
            this.$root.$emit('loading', "end")
            this.$noty.error(`Error: ${er.description}`)
          })
        }
      }
    },
    async created(){
      console.log('create Device')
      await this.getDeviceTypesAction()
      await this.getSubDeviceTypesAction()
      await this.getSubjectCreationData()
    },
  }
</script>
